module.exports = __webpack_public_path__ + "static/media/tela-passo-06.d5aae196.jpg";